'use strict';

var AmxBeaconListenerServiceImpl = require('./AmxBeaconListenerServiceImpl');
require('./KayleeService');
require('./RoomService');

angular.module('inara').factory('AmxBeaconListenerService', AmxBeaconListenerService);

AmxBeaconListenerService.$inject = [ '$rootScope', '$timeout', 'KayleeService', 'RoomService' ];

function AmxBeaconListenerService($rootScope, $timeout, KayleeService, RoomService) {
    var isBrowser = process.env.appEnv === 'browser';
    var isUiPreview = RoomService.isUiPreview();

    if (!isBrowser && !isUiPreview) {
        var impl = new AmxBeaconListenerServiceImpl.AmxBeaconListenerServiceImpl(
            $rootScope,
            KayleeService,
            RoomService
        );
        return {
            isRunning: function() { return impl.isRunning; },
        };
    } else {
        return {
            isRunning: function() { return false; },
        };
    }
}

module.exports = AmxBeaconListenerService;
